import React, { useEffect, useRef, useState } from "react";

// Scroll-triggered entrance animation wrapper.
export const Reveal = ({ children, as: Tag = "div", className = "", delay = 0, style = {}, ...rest }) => {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setShown(true);
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      className={`reveal ${shown ? "in" : ""} ${className}`}
      style={{ transitionDelay: `${delay}ms`, ...style }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export const Eyebrow = ({ children }) => (
  <div className="eyebrow" style={{ marginBottom: "0.9rem" }}>
    {children}
  </div>
);

export const Ornament = ({ style = {} }) => (
  <div className="ornament" style={style}>
    <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true">
      <path d="M6 0 L8 4 L12 6 L8 8 L6 12 L4 8 L0 6 L4 4 Z" fill="currentColor" />
    </svg>
  </div>
);

// Section heading block used across pages.
export const SectionHeading = ({ eyebrow, title, sub, align = "left", light = false }) => (
  <div style={{ textAlign: align, maxWidth: align === "center" ? 760 : "none", margin: align === "center" ? "0 auto" : 0 }}>
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <h2 className="h-section" style={light ? { color: "#fff" } : {}}>
      {title}
    </h2>
    {sub && (
      <p className="h-sub" style={{ marginTop: "0.75rem" }}>
        {sub}
      </p>
    )}
  </div>
);

// Inner-page hero — image background, or a clean light gradient (light mode).
export const PageHero = ({ image, title, sub, align = "left", objectPosition = "center", overlay, light = false }) => (
  <section className={`page-hero${light ? " page-hero-light" : ""}`}>
    {!light && (
      <>
        <div className="page-hero-bg">
          <img src={image} alt="" loading="eager" style={{ objectPosition }} />
        </div>
        <div className="page-hero-overlay" style={overlay ? { background: overlay } : undefined} />
      </>
    )}
    <div className="container-page page-hero-content" style={{ width: "100%" }}>
      <div style={{ maxWidth: 780, margin: align === "center" ? "0 auto" : 0, textAlign: align }}>
        <Ornament style={{ marginBottom: "1.1rem", color: "var(--gold-strong)" }} />
        <h1>{title}</h1>
        {sub && <p className="h-sub" style={{ marginTop: "1rem" }}>{sub}</p>}
      </div>
    </div>
  </section>
);
